import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import './SignupHeader.scss';
import PageHeader from '../PageHeader/PageHeader';

const SignupHeader = (props) => {
  const title = props.title;
  const breadcrumbs = {
    Checkout: '1. Complete your details',
    Payment: '2. Review & Payment'
  };

  const displayBreadcrumb = (val, key) => {
    if (key === title) {
      return (<li className="checkout-header-breadcrumb checkout-header-breadcrumb-active" key={key}>{val}</li>);
    }
    return (<li className="checkout-header-breadcrumb" key={key}>{val}</li>);
  };

  return (
    <div>
      <PageHeader title={title} />
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <ol className="checkout-header-breadcrumbs list-inline">
              {map(breadcrumbs, (val, key) => displayBreadcrumb(val, key))}
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

SignupHeader.propTypes = {
  title: PropTypes.string
};

SignupHeader.defaultProps = {
  title: 'Checkout'
};

export default SignupHeader;



/** WEBPACK FOOTER **
 ** ./src/components/SignupHeader/SignupHeader.js
 **/